"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormFieldContext = void 0;
var _react = require("react");
var FormFieldContext = /*#__PURE__*/(0, _react.createContext)({});
exports.FormFieldContext = FormFieldContext;